goog.require('el8.app.setup');
goog.require('el8.data.practiceUsers');
goog.require("el8.util.amplitude.helpers");

var el8 = el8 || {};
if(!el8.main) { el8.main = {}; }
el8.main.onboarding = {};

el8.main.onboarding.init = function(spec) {
    spec['layout'] = {innerContainerSelector: '#root', notLegacy: true};

    // Initializes el8 globals and enables legacy header nav links
    el8.app.setup(spec);
};
